module.exports = __webpack_public_path__ + "static/media/new_logo.9fac7088.png";